import { createRouter, createWebHashHistory } from 'vue-router'


// import NProgress from 'nprogress'
// import 'nprogress/nprogress.css'


/* Layout */
import Layout from "@/layout/index.vue"
import { getToken } from "@/utils/index";

const routes = [


    //routes第一个对象 会进行左侧菜单的显示判断
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        children: [

            {
            path: '/dashboard',
            alwaysShow: true,
            component: () =>
                import ('@/views/dashboard/index'),
            name: 'Dashboard',
            meta: { title: '首页', icon: 'HomeFilled', affix: true }
            },

            {
                path: '/config',
                alwaysShow: true,
                name: 'config',
                meta: {
                    title: '系统配置',
                    icon: 'Setting'
                },
                children: [{
                    path: "/config",
                    name: "config",
                    alwaysShow: true,
                    meta: {
                        title: '基本配置',
                        icon: ''
                    },
                    component: () => import("@/views/config/config.vue"),
                },
                {
                    path: "/banner",
                    alwaysShow: true,
                    name: "banner",
                    meta: {
                        title: 'Banner配置',
                        icon: ''
                    },
                    component: () => import("@/views/config/banner.vue"),
                },
                ]

            },

        


            {
                path: '/member',
                alwaysShow: true,
                name: 'Member',
                meta: {
                    title: '会员管理',
                    icon: 'User'
                },
                children: [{
                    path: "/userList",
                    name: "userList",
                    alwaysShow: true,
                    meta: {
                        title: '用户管理',
                        icon: ''
                    },
                    component: () => import("@/views/member/userList.vue"),
                },
                // {
                //     path: "/jishiList",
                //     name: "jishiList",
                //     alwaysShow: true,
                //     meta: {
                //         title: '技师管理',
                //         icon: ''
                //     },
                //     component: () => import("@/views/member/jishiList.vue"),
                // },
                // {
                //     path: "/storeList",
                //     name: "storeList",
                //     alwaysShow: true,
                //     meta: {
                //         title: '商家管理',
                //         icon: ''
                //     },
                //     component: () => import("@/views/member/storeList.vue"),
                // },
                ]

            },

            // {
            //     path: '/team',
            //     alwaysShow: true,
            //     name: 'team',
            //     meta: {
            //         title: '团队管理',
            //         icon: 'Connection'
            //     },
            //     children: [{
            //         path: "/teamList",
            //         name: "teamList",
            //         alwaysShow: true,
            //         meta: {
            //             title: '团队管理',
            //             icon: ''
            //         },
            //         component: () => import("@/views/team/teamList.vue"),
            //     },
                
            //     ]

            // },


            {
                path: '/article',
                alwaysShow: true,
                name: 'article',
                meta: {
                    title: '文章管理',
                    icon: 'Document'
                },
                children: [
                    {
                        path: "/categoryArticleList",
                        name: "categoryArticleList",
                        alwaysShow: true,
                        meta: {
                            title: '文章分类',
                            icon: ''
                        },
                        component: () => import("@/views/article/categoryList.vue"),
                        },
                    {
                        path: "/articleList",
                        name: "articleList",
                        alwaysShow: true,
                        meta: {
                            title: '文章管理',
                            icon: ''
                        },
                        component: () => import("@/views/article/articleList.vue"),
                    },
                ]

            },



            // {
            //     path: '/goods',
            //     alwaysShow: true,
            //     name: 'goods',
            //     meta: {
            //         title: '商品管理',
            //         icon: 'Goods'
            //     },
            //     children: [
            //         {
            //             path: "/categoryList",
            //             name: "categoryList",
            //             alwaysShow: true,
            //             meta: {
            //                 title: '商品分类',
            //                 icon: ''
            //             },
            //             component: () => import("@/views/goods/categoryList.vue"),
            //             },
            //         {
            //             path: "/goodsList",
            //             name: "goodsList",
            //             alwaysShow: true,
            //             meta: {
            //                 title: '商品管理',
            //                 icon: ''
            //             },
            //             component: () => import("@/views/goods/goodsList.vue"),
            //         },
            //     ]

            // },

            {
                path: '/product',
                name: 'product',
                alwaysShow: true,
                meta: {
                    title: '产品管理',
                    icon: 'TakeawayBox'
                },
                children: [
                    // {
                    //     path: "/categoryProduct",
                    //     name: "categoryProduct",
                    //     alwaysShow: true,
                    //     meta: {
                    //         title: '项目分类',
                    //         icon: ''
                    //     },
                    //     component: () => import("@/views/product/categoryList.vue"),
                    //     },
                    {
                        path: "/productList",
                        name: "productList",
                        alwaysShow: true,
                        meta: {
                            title: '产品管理',
                            icon: ''
                        },
                        component: () => import("@/views/product/productList.vue"),
                    },
                ]

            },


            {
                path: '/app',
                name: 'app',
                alwaysShow: true,
                meta: {
                    title: 'App管理',
                    icon: 'Cellphone'
                },
                children: [
                    {
                        path: "/appList",
                        name: "appList",
                        alwaysShow: true,
                        meta: {
                            title: 'App管理',
                            icon: ''
                        },
                        component: () => import("@/views/app/appList.vue"),
                    },
                ]

            },

            {
                path: '/device',
                name: 'device',
                alwaysShow: true,
                meta: {
                    title: '设备管理',
                    icon: 'Monitor'
                },
                children: [
                    {
                        path: "/deviceList",
                        name: "deviceList",
                        alwaysShow: true,
                        meta: {
                            title: '设备列表',
                            icon: ''
                        },
                        component: () => import("@/views/device/deviceList.vue"),
                    },
                ]

            },

            {
                path: '/order',
                alwaysShow: true,
                name: 'order',
                meta: {
                    title: '订单管理',
                    icon: 'ShoppingCart'
                },
                children: [
                    // {
                    //     path: "/orderList",
                    //     name: "orderList",
                    //     alwaysShow: true,
                    //     meta: {
                    //         title: '商品订单',
                    //         icon: ''
                    //     },
                    //     component: () => import("@/views/order/orderList.vue"),
                    // },
                    {
                        path: "/orderProductList",
                        name: "orderProductList",
                        alwaysShow: true,
                        meta: {
                            title: '产品订单',
                            icon: ''
                        },
                        component: () => import("@/views/order/orderProductList.vue"),
                    },
                
                ]

            },

            {
                path: '/account',
                alwaysShow: true,
                name: 'account',
                meta: {
                    title: '财务管理',
                    icon: 'CreditCard'
                },
                children: [
                    {
                        path: "/userAccountList",
                        name: "userAccountList",
                        alwaysShow: true,
                        meta: {
                            title: '用户资金',
                            icon: ''
                        },
                        component: () => import("@/views/account/userAccountList.vue"),
                    },
                    // {
                    //     path: "/jishiAccountList",
                    //     name: "jishiAccountList",
                    //     alwaysShow: true,
                    //     meta: {
                    //         title: '技师资金',
                    //         icon: ''
                    //     },
                    //     component: () => import("@/views/account/jishiAccountList.vue"),
                    // },
                    // {
                    //     path: "/storeAccountList",
                    //     name: "storeAccountList",
                    //     alwaysShow: true,
                    //     meta: {
                    //         title: '商户资金',
                    //         icon: ''
                    //     },
                    //     component: () => import("@/views/account/storeAccountList.vue"),
                    // },
                    {
                        path: "/rechargeList",
                        name: "rechargeList",
                        alwaysShow: true,
                        meta: {
                            title: '充值订单',
                            icon: ''
                        },
                        component: () => import("@/views/account/rechargeList.vue"),
                    },
                    // {
                    //     path: "/accountExtractList",
                    //     name: "accountExtractList",
                    //     alwaysShow: true,
                    //     meta: {
                    //         title: '提现订单',
                    //         icon: ''
                    //     },
                    //     component: () => import("@/views/account/accountExtractList.vue"),
                    // },
                    
                    {
                        path: "/accountLogList",
                        name: "accountLogList",
                        alwaysShow: true,
                        meta: {
                            title: '资金明细',
                            icon: ''
                        },
                        component: () => import("@/views/account/accountLogList.vue"),
                    },
                ]

            },


            // {
            //     path: '/score',
            //     alwaysShow: true,
            //     name: 'score',
            //     meta: {
            //         title: '积分管理',
            //         icon: 'Coin'
            //     },
            //     children: [{
            //         path: "/scoreList",
            //         name: "scoreList",
            //         alwaysShow: true,
            //         meta: {
            //             title: '积分管理',
            //             icon: ''
            //         },
            //         component: () => import("@/views/score/scoreList.vue"),
            //     },
        
                
            //     {
            //         path: "/scoreLogList",
            //         name: "scoreLogList",
            //         alwaysShow: true,
            //         meta: {
            //             title: '积分明细',
            //             icon: ''
            //         },
            //         component: () => import("@/views/score/scoreLogList.vue"),
            //     },
            //     ]

            // },

            // {
            //     path: '/marketing',
            //     alwaysShow: true,
            //     name: 'coupon',
            //     meta: {
            //         title: '营销管理',
            //         icon: 'Reading'
            //     },
            //     children: [{
            //         path: "/coupon",
            //         name: "coupon",
            //         alwaysShow: true,
            //         meta: {
            //             title: '优惠券管理',
            //             icon: ''
            //         },
            //         component: () => import("@/views/marketing/coupon.vue"),
            //     },
            //     {
            //         path: "/couponItems",
            //         name: "couponItems",
            //         alwaysShow: true,
            //         meta: {
            //             title: '优惠券记录',
            //             icon: ''
            //         },
            //         component: () => import("@/views/marketing/couponItems.vue"),
            //     },
        
                
                
            //     ]

            // },
            
            

            // {
            //     path: "/test",
            //     name: "test",
            //     meta: {
            //         title: '测试',
            //         icon: 'TakeawayBox'
            //     },
            //     component: () => import("@/views/test/index.vue"),
            // },


            {
                path: "/password",
                alwaysShow: false,
                name: "test",
                meta: {
                    title: '修改密码',
                    icon: 'TakeawayBox'
                },
                component: () => import("@/views/admin/password.vue"),
            },


            



            
    

        ]
    },
   

    //routes第二个对象 不不不不会进行左侧菜单的显示判断
    {
        path: '/login',
        name: 'login',
        alwaysShow: true,
        meta: { title: '登录' },
        component: () =>
            import('@/views/login/login.vue'),
    },


    






]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})




router.beforeEach((to, from, next) => {
    // NProgress.inc(0.2)
    // NProgress.configure({ easing: 'ease', speed: 600, showSpinner: false, parent: '#app' })
    // 
    // NProgress.start();

    let hasToken = false;
    let user = {'token':getToken()}
    if (user.token) {
        hasToken = true;
    } else {
        hasToken = false;
    }

    if (hasToken) {

        //console.log('yes login')
        if (to.path === '/login') {
            next('/dashboard');
        } else {
            next();
        }

    } else {

        /* has no token*/
        if (to.path === '/login') {
            next()
        } else {
            next('/login')
        }

    }

    //next()


})

router.afterEach(() => {

    // NProgress.done()
})

export default router
